module.exports = __webpack_public_path__ + "img/flag_fr.85556bea.svg";